var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.003 10.3-.006.539a1.309 1.309 0 0 0-.991 2.268 1.308 1.308 0 0 0 .992.344l-.01 2.613-13.917-.026v-1.602M14.634 3.154a1.3 1.3 0 0 0 .905 2.405l.912 2.484L3.355 12.89l-.908-2.444a1.31 1.31 0 0 0-.91-2.454L.63 5.548 13.726.71l.908 2.444z",
    stroke: "#CCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.67a372b1ef19b1f275b48d3a0105fc49.svg";
export { ForwardRef as ReactComponent };